module.exports = __webpack_public_path__ + "static/media/portal_bg.0a3de3ae.png";